/**
 * Scrolls the scrollContainer a bit if the user clicks on the bottom part of the container.
 * @param scrollContainer The container that will be scrolled.
 * @param scrolledContent The content that is being scrolled.
 * @param clientY The Y coordinate of the click event.
 */
export default function scrollABit(scrollContainer: Element, scrolledContent: Element, clientY: number) {
  const { height } = scrollContainer.getBoundingClientRect()

  // ~ 20% of the bottom part
  const clickPointThreshold = height * 0.8
  const isTriggerArea = clientY > clickPointThreshold

  if (!isTriggerArea) return

  scrollContainer?.scrollBy({ top: 300, behavior: 'smooth' })
}
